<template>
  <div class="h-wrap" v-if="!isMobile">
    <div class="logo"><img src="../assets/header/logo.png" alt="" /></div>
    <div>
      <div class="nav">
        <el-menu
          text-color="#000"
          active-text-color="#004C31"
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
        >
          <el-menu-item
            v-for="(item, index) in nav"
            :index="index.toString()"
            :key="index"
            >{{ item.name }}</el-menu-item
          >
        </el-menu>
        <!--               <div class="navItem" v-for="(item,index) in nav" :style="{color:  active == index ? '#004C31' : ' #000',fontWeight:  active == index ? 'bold' : ' '}" @click="tab(item)"  :key="index">{{item.name}}</div>-->
      </div>
      <!--           <div class="activeNav" :style="{width:Num,transform:'translateX('+Left+')',transition:' all 0.4s ease'}"></div>-->
    </div>
  </div>
  <div class="moh-wrap" v-else>
    <div class="logo"><img src="../assets/index/footerLogo.png" alt="" /></div>
    <!--        <van-icon size="30px" color="#ffffff" name="wap-home-o" @click="openMenu" />-->
    <div style="display;flex;justify-content:center">
      <img
        src="../assets/header/menu.jpg"
        alt=""
        @click="openMenu"
        style="width: 21px; height: auto"
      />
    </div>
    <van-popup
      v-model="show"
      position="right"
      style="width: 40%; right: 0; height: 100%"
      @close="closePop"
    >
      <!--            <div class="navItem" v-for="(item,index) in nav" :style="{color:  active == index ? '#004C31' : ' #000',fontWeight:  active == index ? 'bold' : ' '}" @click="tab(item)"  :key="index">{{item.name}}</div>-->
      <el-menu
        style="z-index: 2001"
        text-color="#000"
        active-text-color="#004C31"
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="vertical"
        @select="handleSelect"
      >
        <el-menu-item
          style="height: 30px; line-height: 30px"
          v-for="(item, index) in nav"
          :index="index.toString()"
          :key="index"
          >{{ item.name }}</el-menu-item
        >
      </el-menu>
    </van-popup>

    <!--        <div>-->
    <!--            <div class="nav">-->
    <!--                <el-menu text-color="#000"  active-text-color="#004C31" :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">-->
    <!--                    <el-menu-item  v-for="(item,index) in nav" :index="index.toString()"  :key="index">{{item.name}}</el-menu-item>-->
    <!--                </el-menu>-->
    <!--                &lt;!&ndash;               <div class="navItem" v-for="(item,index) in nav" :style="{color:  active == index ? '#004C31' : ' #000',fontWeight:  active == index ? 'bold' : ' '}" @click="tab(item)"  :key="index">{{item.name}}</div>&ndash;&gt;-->
    <!--            </div>-->
    <!--            &lt;!&ndash;           <div class="activeNav" :style="{width:Num,transform:'translateX('+Left+')',transition:' all 0.4s ease'}"></div>&ndash;&gt;-->
    <!--        </div>-->
  </div>
</template>

<script>
export default {
  name: "Header",
  props: {
    navIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      activeKey: 0,
      show: false,
      isMobile: this.$isMobile,
      activeIndex: "1",
      Left: "0px",
      Num: "32px",
      active: 0,
      nav: [
        { name: "首页", id: 0, cont: "index" },
        { name: "关于阁韵", id: 1, cont: "about" },
        { name: "专业定制", id: 2, cont: "customized" },
        { name: "产品介绍", id: 3, cont: "goods" },
        { name: "服务介绍", id: 4, cont: "service" },
        { name: "阁韵动态", id: 5, cont: "Dynamic" },
        { name: "阁韵案例", id: 6, cont: "anli" },
        { name: "招商加盟", id: 7, cont: "attract" },
        { name: "联系我们", id: 8, cont: "concat" },
      ],
    };
  },
  mounted() {
    // console.log(this.isMobile);
  },
  watch: {
    navIndex: {
      immediate: true,
      handler: function (newVal, oldVal) {
        this.activeIndex = newVal.toString();
        // console.log(newVal, oldVal, "jianting");
      },
      deep: true,
    },
  },
  methods: {
    closePop() {
      this.$emit("handleFunc", "false");
    },
    openMenu() {
      var that = this;
      this.show = true;
      if (this.activeKey == 0) {
        that.$emit("handleFunc", "true");
      }
    },
    handleSelect(key, keyPath) {
      var that = this;
      // console.log(key, keyPath);
      this.activeKey = key;
      switch (key) {
        case "0":
          this.$router.push({ name: "index" });
          break;
        case "1":
          this.$router.push({ name: "about" });
          break;
        case "2":
          this.$router.push({ name: "customized" });
          break;
        case "3":
          this.$router.push({ name: "goods" });
          break;
        case "4":
          this.$router.push({ name: "service" });
          break;
        case "5":
          this.$router.push({ name: "Dynamic" });
          break;
        case "6":
          this.$router.push({ name: "anli" });
          break;
        case "7":
          this.$router.push({ name: "attract" });
          break;
        case "8":
          this.$router.push({ name: "concat" });
          break;
      }
    },
    tab(item) {
      //  let num=window.event.target.offsetWidth;
      //  let positionNum=window.event.target.offsetLeft;
      // window.console.log(positionNum)
      // this.Num=num+"px";
      // this.Left=positionNum+"px";
      // console.log(num,positionNum)
      this.$router.push({ name: item.cont });
      // this.$store.dispatch("SortGoods",obj)
    },
  },
};
</script>

<style scoped lang="less">
.el-menu.el-menu--horizontal {
  border-bottom: unset !important;
}
.el-menu--horizontal > .el-menu-item {
  height: 5.75rem;
  /*border-bottom-color:#f8d35d !important;*/
  line-height: 5.75rem;
}
.h-wrap {
  width: 1280px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .logo {
    width: 140px;
    height: 50px;
    margin: 20px 0px;
    img {
      width: 140px;
      height: 50px;
    }
  }
  .activeNav {
    position: absolute;
    border-bottom: 4px solid #f8d35d;
    padding-top: 32px;
    z-index: 200;
  }
  .nav {
    position: relative;
    display: flex;
    align-items: center;
    .navItem {
      cursor: pointer;
      margin-right: 28px;
      font-family: 微软雅黑, MicrosoftYaHei;
      color: #000;
      font-size: 14px;
    }
  }
}
.moh-wrap {
  background: #004c31;

  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .logo {
    width: 450px;
    height: 150px;
    margin: 20px 0px;
    img {
      width: 450px;
      height: 150px;
    }
  }
  .activeNav {
    position: absolute;
    border-bottom: 4px solid #f8d35d;
    padding-top: 32px;
    z-index: 200;
  }
  .nav {
    position: relative;
    display: flex;
    align-items: center;
    .navItem {
      cursor: pointer;
      margin-right: 28px;
      font-family: 微软雅黑, MicrosoftYaHei;
      color: #000;
      font-size: 42px;
    }
  }
}
@media screen and (max-width: 450px) {
  // .moh-wrap {
  //   background: #004c31;

  //   // margin: 0 auto;
  //   display: flex;
  //   // align-items: center;
  //   // justify-content: space-between;
  //   .logo {
  //     width: 450px;
  //     height: 150px;
  //     margin: 20px 0px;
  //     img {
  //       width: 450px;
  //       height: 150px;
  //     }
  //   }
  // }
  /deep/.el-menu-item {
    font-size: 72px;
  }
}
</style>
